// extracted by mini-css-extract-plugin
export default {"wrapper":"KanbanTable_wrapper__zl-+g","item__wrapper":"KanbanTable_item__wrapper__T44gy"};